<!-- Your main application content here -->
<!--<app-admin-layout *ngIf="!isAuthenticating"></app-admin-layout>

<div *ngIf="isAuthenticating">
  Authenticating...Please wait
</div>-->
<app-loading-indicator *ngIf="appLoader.isLoading" [text]="appLoader.loaderText"></app-loading-indicator>

<app-loading-indicator *ngIf="isLoadingInternal" [internal]="true" text="Saving...Please Wait"></app-loading-indicator>

<router-outlet></router-outlet>
<!-- Cookies banner-->
<!-- <sca-app-cookies #cookies></sca-app-cookies> -->

<!-- <footer class="sabis-careers-portal__footer">
  <a routerLink="/privacy-policy" target="_blank">Privacy Policy</a>
  <span>-</span>
  <a routerLink="/guidelines" target="_blank">Guidelines</a>
  <span>-</span>
  <a routerLink="/terms-and-conditions" target="_blank">Terms and Conditions</a>
</footer> -->